
import { Permissions } from "./PermissionEnum";

export default class UserGroup 
{
	static readonly Permissions = Permissions // allows UserGroup.Permissions.*

	public id = 0;
	public name = "";
	public permissions : Permissions = Permissions.None;
	public powerlevel = 0;
	public powerlevellocked = false;
}